export const PAGE_SIZE = 30

// ALLIANCE BUSINESS LOGIC
export const alliance = {
    friendly: 'Friendly',
    neutral: 'Neutral',
    enemy: 'Enemy',
}

// THREAT LEVELS
export const threat_level = {
    UNCLASSIFIED: 'Unclassified',
    FRIENDLY: 'Friendly',
    UNCERTAIN: 'Uncertain',
    SUSPECT: 'Suspect',
}

// ENTITY TYPES BUSINESS LOGIC
export const entity_types = {
    drone: 'Drone',
    gcs: 'GCS',
    sensor: 'Sensor',
    effector: 'Effector',
}

// AREA TYPES BUSINESS LOGIC
export const area_types = {
    neutral: 'Neutral',
    protected: 'Protected',
    buffer: 'Buffer',
}

// AREA TYPES FOR SELECTOR CONTROL
export const selector_area_types = [
    {
        value: 'Protected',
        label: 'Restricted',
    },
    {
        value: 'Buffer',
        label: 'Buffer',
    },
]

// PAYLOAD ENTITY TYPES FOR SELECTOR CONTROL
export const selector_entity_payload_types = [
    {
        value: 'Sensor',
        label: 'Sensor',
    },
    {
        value: 'Effector',
        label: 'Effector',
    },
]

// ENTITY TYPES FOR SELECTOR CONTROL
export const selector_entity_types = [
    {
        value: 'Drone',
        label: 'Drone',
    },
    {
        value: 'GCS',
        label: 'GCS',
    },
]

// ENTITY ALLIANCE (RED) FOR SELECTOR CONTROL
export const selector_alliance_types = [
    {
        value: 'Neutral',
        label: 'Neutral',
    },
    {
        value: 'Enemy',
        label: 'Intruder',
    },
]

// ACTION TYPES FOR ASSET SELECTED
export const assetActionTypes = {
    UPDATE_ASSET_SELECTION: 'update_blue_selection',
    RESET_ASSET_SELECTION: 'reset_blue_selection',
    UPDATE_DETECTION_SELECTION: 'update_detection_selection',
    RESET_DETECTION_SELECTION: 'reset_detection_selection',
    UPDATE_DETECTION_LIST: 'update_detection_list',
    CLEAR_DETECTION_LIST: 'clear_detection_list',
}

// ACTION TYPES FOR ASSET DRAWER
export const drawerActionTypes = {
    OPEN_ASSETS: 'open_left',
    CLOSE_ASSETS: 'close_left',
    OPEN_DETECTIONS: 'open_right',
    CLOSE_DETECTIONS: 'close_right',
}
